import "./PrivateDining.module.css";
import Header from "@/reusable_sections/Header";
import HostYourStory from "./sections/HostYourStory";
import TheArtOfTheExperience from "./sections/TheArtOfTheExperience";
import ReserveATable from "./sections/ReserveATable";
import Footer from "@/reusable_sections/Footer";
export default function PrivateDiningPage() {
  return <div>
      <Header />
      <HostYourStory />
      <TheArtOfTheExperience />
      <ReserveATable />
      <Footer />
    </div>;
}